<template>
  <div
    v-if="visible"
    class="message-context-menu"
    :style="menuStyle"
    @click.stop
    @contextmenu.prevent
  >
    <ul class="menu-list">
      <li
        v-for="(item, index) in menuItems"
        :key="index"
        class="menu-item"
        @click="handleMenuClick(item)"
      >
        <i v-if="item.icon" class="menu-icon" :class="item.icon"></i>
        <span class="menu-text">{{ item.text }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "MessageContextMenu",
  props: {
    menuItems: {
      type: Array,
      default: () => [],
      // 菜单项数组，每项应包含 { text: '菜单文本', value: '菜单值', icon: '可选图标类名' }
    },
    position: {
      type: Object,
      default: () => ({ x: 0, y: 0 }),
    },
  },
  data() {
    return {
      visible: false,
      menuStyle: {
        top: "0px",
        left: "0px",
      },
    };
  },
  watch: {
    position: {
      handler(newVal) {
        this.updatePosition(newVal);
      },
      deep: true,
    },
  },
  mounted() {
    document.addEventListener("click", this.hideMenu);
    document.addEventListener("contextmenu", this.hideMenuOnOtherContextMenu);
    window.addEventListener("resize", this.hideMenu);
    window.addEventListener("scroll", this.hideMenu, true);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.hideMenu);
    document.removeEventListener(
      "contextmenu",
      this.hideMenuOnOtherContextMenu
    );
    window.removeEventListener("resize", this.hideMenu);
    window.removeEventListener("scroll", this.hideMenu, true);
  },
  methods: {
    show(position) {
      // 强制设置为false先，再设置为true，确保触发视图更新
      this.visible = false;

      // 使用setTimeout确保DOM更新后再设置为true
      setTimeout(() => {
        this.visible = true;
        console.log("==zy==show visible:", this.visible);

        // 更新位置
        this.updatePosition(position);
      }, 0);
    },
    hide() {
      this.visible = false;
    },
    hideMenu() {
      this.visible = false;
    },
    hideMenuOnOtherContextMenu(e) {
      // 如果右键点击不在菜单内部，则隐藏菜单
      if (this.visible && !this.$el.contains(e.target)) {
        this.visible = false;
      }
    },
    updatePosition(position) {
      if (!this.visible) return;

      // 确保菜单已经渲染到DOM
      this.$nextTick(() => {
        try {
          const menuWidth = this.$el.offsetWidth;
          const menuHeight = this.$el.offsetHeight;
          const windowWidth = window.innerWidth;
          const windowHeight = window.innerHeight;

          // 计算菜单位置，确保不超出视口
          let left = position.x;
          let top = position.y;

          // 如果菜单右侧超出视口，则将菜单放在左侧
          if (left + menuWidth > windowWidth) {
            left = position.x - menuWidth;
          }

          // 如果菜单底部超出视口，则将菜单放在上方
          if (top + menuHeight > windowHeight) {
            top = position.y - menuHeight;
          }

          // 确保菜单不会超出视口左侧和顶部
          left = Math.max(0, left);
          top = Math.max(0, top);

          // 直接修改style对象的属性
          this.menuStyle = {
            top: `${top}px`,
            left: `${left}px`,
          };
        } catch (error) {
          console.error("更新菜单位置时出错:", error);
        }
      });
    },
    handleMenuClick(item) {
      this.$emit("menu-click", item);
      this.hide();
    },
  },
};
</script>

<style lang="scss" scoped>
.message-context-menu {
  position: fixed;
  z-index: 1000;

  min-width: 88px;
  background: #18181b;
  box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.06),
    0px 1px 3px 0px rgba(0, 0, 0, 0.1);
  border-radius: 8px 8px 8px 8px;
  border: 1px solid rgba(229, 231, 235, 0.04);
  overflow: hidden;

  .menu-item {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: background-color 0.2s;

    height: 38px;
    padding: 0 6px;

    font-weight: 500;
    font-size: 14px;
    color: #ecedee;
    line-height: 20px;

    &:hover {
      background-color: rgba($color: #18181b, $alpha: 0.8);
    }
  }

  .menu-icon {
    margin-right: 8px;
    font-size: 16px;
  }

  .menu-text {
    flex: 1;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
  }
}
</style>
